import { ReactElement, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';

import { eventActions } from '../../redux/slices/event.slice';
import { associationActions } from '../../redux/slices/association.slice';
import { organisationActions } from '../../redux/slices/organisation.slice';
import { teamActions } from '../../redux/slices/team.slice';

import EventCreateType from '../../components/event-create-type/event-create-type';
import EventCreateAssociation from '../../components/event-create-association/event-create-association';
import EventCreateOrganisation from '../../components/event-create-organisation/event-create-organisation';
import EventCreateTeam from '../../components/event-create-team/event-create-team';
import EventCreateForm from '../../components/event-create-form/event-create-form';

import { EEventCreateSteps } from '../../types/@event';

const EventsCreate = (): ReactElement => {
  const dispatch = useDispatch();
  const [step, setStep] = useState<number>(EEventCreateSteps.type);

  useEffect(() => {
    dispatch(eventActions.resetEventCreate());

    // These actions are page-based fetches in the current codebase.
    // Their payload type is number | undefined, not a parent entity id.
    dispatch(associationActions.getAssociation(undefined));
    dispatch(organisationActions.getOrganisations(undefined));
    dispatch(teamActions.getTeams(undefined));
  }, [dispatch]);

  return (
    <Box sx={{ width: '100%' }}>
      {step === EEventCreateSteps.type && <EventCreateType setStep={setStep} />}

      {step === EEventCreateSteps.association && <EventCreateAssociation setStep={setStep} />}

      {step === EEventCreateSteps.organisation && <EventCreateOrganisation setStep={setStep} />}

      {step === EEventCreateSteps.team && <EventCreateTeam setStep={setStep} />}

      {step === EEventCreateSteps.event && <EventCreateForm setStep={setStep} />}
    </Box>
  );
};

export default EventsCreate;